import { gsap } from 'gsap';

class SearchAnimation {
  constructor() {
    this.state = 0; // animate forward = 0, reverse = 1;
    this.icons = document.querySelectorAll('.navbar .social-links-loader a');
    this.wrapper = document.querySelector('.navbar .search .wrapper');
    this.button = document.querySelector('.navbar .search-icon>a');
    this.socialbar = document.querySelector('.navbar .social');
    this.search = document.querySelector('.navbar .search');
    this.close = document.querySelector('.navbar .search button');
    this.searchInput = document.querySelector('#marineSearch');
  }

  setSize() {
    const iconWidth = 48;
    const minSize = 6;
    if (this.socialbar) {
      this.socialbar.style.width = `${minSize * iconWidth}px`;
    }
  }

  start() {
    if (this.wrapper && this.search) {
      this.animation();
      this.observe();

      if (this.icons.length === 0) {
        this.setSize();
        this.timeline.play();
      }
    }
  }

  animation() {
    this.timeline = gsap.timeline({ paused: true });
    this.timeline.set(this.icons, {
      transformOrigin: 'bottom center',
    });

    this.timeline.set(this.search, {
      display: 'block',
    });

    if (this.icons.length > 0) {
      this.timeline.to(this.icons, 0.2, {
        opacity: 0,
        transform: 'scale(0.5)',
        ease: 'cubic-bezier(0,0,0,1.1)',
      });
    }

    this.timeline.fromTo(this.wrapper, 0.3, {
      opacity: 0,
      y: -5,
      ease: 'cubic-bezier(0,0,0,1.1)',
    }, {
      opacity: 1,
      y: 0,
      ease: 'cubic-bezier(0,0,0,1.1)',
      onComplete: () => this.searchInput.focus(),
    }, '-=0.1');
  }

  observe() {
    if (this.button) {
      this.button.addEventListener('click', () => {
        if (this.socialbar.classList.contains('animate-on-load')) {
          this.socialbar.classList.remove('animate-on-load');
        }
        if (this.state === 0) {
          this.timeline.play();
          this.state = 1;
        } else {
          this.timeline.reverse();
          this.state = 0;
        }
      });
    }

    if (this.close && this.icons.length > 0) {
      this.close.addEventListener('click', (e) => {
        e.preventDefault();
        this.timeline.reverse();
        this.state = 0;
      }, false);
    }
    // @att: use if no close icon needed
    // when no social icons are displayed
    // else if (this.close) {
    //  this.close.style.display = 'none';
    // }
  }
}

export default SearchAnimation;
